import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=778247f8&scoped=true&"
import script from "./LanguageSelect.vue?vue&type=script&lang=js&"
export * from "./LanguageSelect.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=778247f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778247f8",
  null
  
)

component.options.__file = "LanguageSelect.vue"
export default component.exports